import React, { lazy, Suspense } from 'react';

const LazyPreRegistrationList = lazy(() => import('./PreRegistrationList'));

const PreRegistrationList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazyPreRegistrationList {...props} />
  </Suspense>
);

export default PreRegistrationList;
